import styled from "styled-components";
import { useState } from "react";
import { format } from "date-fns";
import CalendarDual from "../../common/CalendarDual";

interface DateRangeFilterInterface {
    day: Date | undefined
    endDay: Date | undefined
    setDay: (value: Date | undefined) => void
    setEndDay: (value: Date | undefined) => void
}

export default function DateRangeFilter({ day, endDay, setDay, setEndDay }: DateRangeFilterInterface) {
    const [isCalendarOpen, setIsCalendarOpen] = useState(false)

    function reset() {
        setDay(undefined)
        setEndDay(undefined)
        setIsCalendarOpen(false)
    }

    return (
        <Main>
            <div className="date">
                <button type="button" className="open-calendar" onClick={() => setIsCalendarOpen(!isCalendarOpen)}>
                    {day ? `${format(day, 'dd/MM/yyyy')}${endDay ? ' - ' + format(endDay, 'dd/MM/yyyy') : ''}` : 'Todas las fechas'}
                </button>
                <div className={`calendar ${isCalendarOpen ? 'open' : ''}`}>
                    <CalendarDual
                        endDay={endDay}
                        setEndDay={setEndDay}
                        selectedDay={day}
                        setSelectedDay={setDay}
                        selectPastDays
                    />
                    <button type="button" className="reset" onClick={reset}>Restablecer</button>
                </div>
            </div>
            {day && <button type="button" className="all-dates" onClick={reset}>Todas las fechas</button>}
        </Main>
    )
}

const Main = styled.div`
display: flex;
align-items: center;
gap: 10px;
flex-wrap: wrap;
justify-content: center;
margin-bottom: 10px;
.date {
    position: relative;
    z-index: 20;
    > button.open-calendar {
        padding: 10px 20px;
        border-radius: 8px;
        border: none;
        background-color: ${props => props.theme.blueLight};
        color: ${props => props.theme.white};
        cursor: pointer;
        font-weight: 600;
        white-space: nowrap;
    }
    > .calendar {
        display: none;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 20;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        &.open {
            display: flex;
        }
        .reset {
            padding: 8px 16px;
            border-radius: 8px;
            border: 2px solid ${props => props.theme.lightRed};
            background: ${props => props.theme.white};
            color: ${props => props.theme.lightRed};
            cursor: pointer;
            font-weight: 600;
        }
    }
}
.all-dates {
    padding: 10px 16px;
    border-radius: 8px;
    border: 2px solid ${props => props.theme.gray};
    background: transparent;
    color: ${props => props.theme.dark};
    cursor: pointer;
    font-weight: 600;
    white-space: nowrap;
}
`
